import { AviaryProvider } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { useNavigate } from "@shared/react-router-dom/react-router-dom";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import type { PatientAttributes } from "@unauthenticated/shared/data/types/PatientAttributes.d";
import { ConnectNextStepsCard } from "@unauthenticated/signupSignin/components/ConnectNextStepsCard/ConnectNextStepsCard";
import { ConnectPageLayout } from "@unauthenticated/signupSignin/components/ConnectPageLayout/ConnectPageLayout";
import { ConnectPractitionerCard } from "@unauthenticated/signupSignin/components/ConnectPractitionerCard/ConnectPractitionerCard";
import { PatientConnectSignUpForm } from "@unauthenticated/signupSignin/components/PatientConnectSignUpForm/PatientConnectSignUpForm";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

interface Props {
  patientAttributes: PatientAttributes;
}

const PatientConnectSignUpPage = ({ patientAttributes }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pracName, pracAvatar, pracFirstName, pracLastName, storeSlug } = patientAttributes;

  const signInHref = authRoutes.welcomeStart(storeSlug, "");

  const sidebar = (
    <>
      <ConnectPractitionerCard
        pracName={pracName}
        pracAvatar={pracAvatar}
        pracFirstName={pracFirstName}
        pracLastName={pracLastName}
        firstVisitPrice={t(l.connect.practitionerCard.placeholderFirstVisitPrice)}
        subsequentVisitPrice={t(l.connect.practitionerCard.placeholderSubsequentVisitPrice)}
      />
      <ConnectNextStepsCard pracFirstName={pracFirstName ?? pracName} />
    </>
  );

  return (
    <AviaryProvider controlledTheme="light" noNormalization>
      <ConnectPageLayout signInHref={signInHref} onBackClick={() => navigate(-1)} sidebar={sidebar}>
        <PatientConnectSignUpForm signInHref={signInHref} />
      </ConnectPageLayout>
    </AviaryProvider>
  );
};

export { PatientConnectSignUpPage };
export type { Props as PatientConnectSignUpPageProps };
